/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfFileResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfFileResponse } from '../models/index.js';
// @ts-ignore
import { ArchivedRequestBuilderRequestsMetadata, type ArchivedRequestBuilder } from './archived/index.js';
// @ts-ignore
import { FileItemRequestBuilderNavigationMetadata, FileItemRequestBuilderRequestsMetadata, type FileItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { MonthsRequestBuilderRequestsMetadata, type MonthsRequestBuilder } from './months/index.js';
// @ts-ignore
import { PendingRequestBuilderNavigationMetadata, PendingRequestBuilderRequestsMetadata, type PendingRequestBuilder } from './pending/index.js';
// @ts-ignore
import { RevisionsRequestBuilderNavigationMetadata, type RevisionsRequestBuilder } from './revisions/index.js';
// @ts-ignore
import { SearchRequestBuilderRequestsMetadata, type SearchRequestBuilder } from './search/index.js';
// @ts-ignore
import { type UploadRequestBuilder, UploadRequestBuilderNavigationMetadata } from './upload/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files
 */
export interface FilesRequestBuilder extends BaseRequestBuilder<FilesRequestBuilder> {
    /**
     * The archived property
     */
    get archived(): ArchivedRequestBuilder;
    /**
     * The months property
     */
    get months(): MonthsRequestBuilder;
    /**
     * The pending property
     */
    get pending(): PendingRequestBuilder;
    /**
     * The revisions property
     */
    get revisions(): RevisionsRequestBuilder;
    /**
     * The search property
     */
    get search(): SearchRequestBuilder;
    /**
     * The upload property
     */
    get upload(): UploadRequestBuilder;
    /**
     * Gets an item from the ApiSdk.files.item collection
     * @param fileId Unique identifier of the item
     * @returns {FileItemRequestBuilder}
     */
     byFileId(fileId: Guid) : FileItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfFileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<FilesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfFileResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FilesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface FilesRequestBuilderGetQueryParameters {
    directoryId?: Guid;
    month?: string;
    page?: number;
    pageSize?: number;
    sort?: string;
    tagId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const FilesRequestBuilderUriTemplate = "{+baseurl}/files{?directoryId*,month*,page*,pageSize*,sort*,tagId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FilesRequestBuilderNavigationMetadata: Record<Exclude<keyof FilesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFileId: {
        requestsMetadata: FileItemRequestBuilderRequestsMetadata,
        navigationMetadata: FileItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["file%2Did"],
    },
    archived: {
        requestsMetadata: ArchivedRequestBuilderRequestsMetadata,
    },
    months: {
        requestsMetadata: MonthsRequestBuilderRequestsMetadata,
    },
    pending: {
        requestsMetadata: PendingRequestBuilderRequestsMetadata,
        navigationMetadata: PendingRequestBuilderNavigationMetadata,
    },
    revisions: {
        navigationMetadata: RevisionsRequestBuilderNavigationMetadata,
    },
    search: {
        requestsMetadata: SearchRequestBuilderRequestsMetadata,
    },
    upload: {
        navigationMetadata: UploadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FilesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FilesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfFileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
